import { useEffect, useRef } from "react";
import { handleAuthRedirect } from "../utils/auth";

export const useLoginTimeout = (minutes: number = 5) => {
  const timeoutRef = useRef<NodeJS.Timeout>();

  const resetTimer = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      handleAuthRedirect();
    }, minutes * 60 * 1000);
  };

  useEffect(() => {
    const events = ["click", "keypress", "mousemove", "scroll"];

    events.forEach((event) => {
      document.addEventListener(event, resetTimer);
    });

    resetTimer(); // 初回設定

    return () => {
      events.forEach((event) => {
        document.removeEventListener(event, resetTimer);
      });
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [minutes]);
};